import React, { useEffect } from 'react';
import popupFactory from '../hoc/popup';
import cx from 'classnames';
import './toast.less';
interface IProps {
  type: 'success' | 'error';
  msg: string;
  delay: number;
  onClose: () => void;
}
function Toast(props: IProps) {
  const { type = 'success', msg = '', delay = 0 } = props;
  const classes = `g-toast-${type}`;
  useEffect(() => {
    if (delay) {
      setTimeout(function() {
        props.onClose();
      }, delay);
    }
  }, []);
  return (
    <div className={cx('g-toast', classes)}>
      <div className="g-toast-msg">{msg}</div>
      <div className="g-toast-icon" onClick={props.onClose} />
    </div>
  );
}

export default popupFactory(Toast);
